import { useEffect, useRef, useState } from 'react';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import { browserName } from "react-device-detect";

import {
  Grid, useMediaQuery, makeStyles, Button, TextField, ButtonBase, Box,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { sessionActions } from '../../store';
import { useLocalization, useTranslation } from '../../LocalizationProvider';
import StartPage from '../../StartPage';
import usePersistedState from '../../common/usePersistedState';
import { api_call, console_log, getToken, get_utc_timestamp_ms, setToken } from '../../helpers/untils';
import { APP_INTRO_PAGE_LINK, APP_NAME, DEVICE_TYPE, GOOGLE_CHROME_LOGO, GOOGLE_CHROME_URL, MACHINE_ENVIRONMENT, RECAPTCHA_ENABLED } from '../../config/constant';
import { convertObjectToQueryString, getSettingPersist, setSettingPersist } from '../../helpers/misc';
import CaptchaBox from '../CaptchaBox';
import LoginAgreeModal from './LoginAgreeModal';
import ConfirmDialog from '../ConfirmDialog';
import { Stack } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    textAlign: 'center',
    color: theme.palette.primary.main,
  },
  resetPassword: {
    cursor: 'pointer',
  },
  chromeLogoContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor: '#e5e5e5',
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
    marginTop: '1rem',
    marginBottom: '1rem',
    padding: '4px',
  },
  chromeLogoImg: {
    width: 'calc(100% - 210px)',
    height: 'auto'
  },
  chromeLogoTxt: {
    flex: 1,
    paddingLeft: '0.5rem',
    textAlign: 'left',
    fontSize: '20px',
    fontWeight: '700',
    color: '#333333',
  },
}));

const LoginForm = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const t = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const currentURL = window.location.href;
  const currentPath = window.location.pathname;
  const currentQuery = window.location.search;
  const get_params = new URLSearchParams(window.location.search);
  const redirect_url = get_params.get('redirect_url');
  //console.log(`currentURL,currentPath, currentQuery::: ${currentURL}, ${currentPath}, ${currentQuery}, ${redirect_url}`);
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const { languages, language, setLanguage } = useLocalization();
  const languageList = Object.entries(languages).map((values) => ({ code: values[0], name: values[1].name }));

  const userRef = useRef()
  const [showAgreeModal, setShowAgreeModal] = useState(false);

  const [failed, setFailed] = useState(false);

  const [email, setEmail] = usePersistedState('loginEmail', (MACHINE_ENVIRONMENT === 'dev' ? 'quanseng632@gmail.com' : ''));
  const [password, setPassword] = useState(MACHINE_ENVIRONMENT === 'dev' ? '123456' : '');

  ///////////// start recaptcha part //////////////////////////////////////////////////////////////////////////
  const captchaKey = 'captcha_login'
  const [recaptcha, setRecaptcha] = useState(RECAPTCHA_ENABLED === "false" ? "xxxxxxxxxxxxxxxxx" : "");
  const [captchaTimestamp, setCaptchaTimestamp] = useState(get_utc_timestamp_ms());
  const updateCaptchaSettingEnabled = (value) => {
    const oldValue = getSettingPersist(captchaKey)
    if (true || oldValue !== value) { // refresh every attempt
      setSettingPersist(captchaKey, value)
      setCaptchaTimestamp(get_utc_timestamp_ms())
    }
  }
  ///////////// end recaptcha part //////////////////////////////////////////////////////////////////////////

  const handleSubmit = async (event) => {
    event.preventDefault();
    const rand = () => Math.floor((1 + Math.random()) * 0x100000000).toString(16).substring(1);
    const session = rand();
    window.localStorage.setItem('session', session);
    var data = { email: email, password: password, session: session };
    const response = await api_call('/api/auth', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // body: new URLSearchParams(`email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`),
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const user = await response.json();
      console_log("user::::", user);
      updateCaptchaSettingEnabled(false)

      const isNewUser = user['isNewUser']
      if (isNewUser) {
        userRef.current = user
        setShowAgreeModal(true)
      } else {
        processAfterLogin(user)
      }

    } else {
      updateCaptchaSettingEnabled(true)

      setFailed(true);
      setPassword('');
    }
  }

  const processAfterLogin = (user, queryParams = null) => {
    setToken(user.token)
    window.localStorage.setItem('isAdministrator', user.administrator ? '1' : '0');
    dispatch(sessionActions.updateUser(user));

    let shouldAddDevice = true; // should go to "add new device" page
    if (user['administrator']) {
      shouldAddDevice = false;
    }
    const userDeviceCount = user['userDeviceCount'];
    if (userDeviceCount && userDeviceCount > 0) {
      shouldAddDevice = false;
    }
    const userCoHostDeviceIds = user['userCoHostDeviceIds'];
    if (userCoHostDeviceIds && userCoHostDeviceIds.length > 0) {
      shouldAddDevice = false;
    }

    updateCaptchaSettingEnabled(false)

    if (currentPath !== '/login') {
      window.location.reload();
      return true
    }
    else if (redirect_url) {
      window.location.href = redirect_url;
      return true
    }

    if (shouldAddDevice) {
      //history.push('/device');
      window.location.href = '/device';
    } else {
      let redirectUrl = `/main`
      if (queryParams) {
        const queryString = convertObjectToQueryString(queryParams)
        if (queryString) {
          redirectUrl += `?${queryString}`
        }
      }
      // history.push(redirectUrl)
      window.location.href = redirectUrl;
    }
  }

  const handleSpecialKey = (e) => {
    if (e.keyCode === 13 && email && password && recaptcha) {
      handleSubmit(e);
    }
  };

  const [isChrome, setIsChrome] = useState(true);

  useEffect(() => {
    // window.localStorage.removeItem('session');
    // dispatch(sessionActions.updateUser(null));
    console.log("browserName", browserName)
    if (browserName.indexOf("Chrome") > -1) {
      setIsChrome(true);
    } else {
      setIsChrome(false);
    }

    checkLoggedin()
  }, []);

  const checkLoggedin = async () => {
    const m_token = getToken();
    if (m_token) {
      window.location.href = '/main';
    }
  }

  const applyLogout = async () => {
    const m_token = getToken();
    if (m_token) {
      const url = `/api/auth`
      const response = await api_call(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      setToken("")
    }
  }

  const onClickAgree = () => {
    //console.log('onClickAgree::::')
    handleAgreeSubmit()
    //setShowAgreeModal(false)

  }

  const onClickCancel = () => {
    setShowAgreeModal(false)
  }

  const handleAgreeSubmit = async () => {
    const user = userRef.current
    var data = { token: user.token };
    const response = await api_call('/api/auth-agree', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      let queryParams = null
      if (user.signup_source === DEVICE_TYPE.SMARTCAR) {
        queryParams = {
          showEscrowPage: 'true'
        }
      }
      processAfterLogin(user, queryParams)
    } else {
      window.alert("Invalid request!")
    }
  }

  const onClickSmartcarSignup = async () => {
    history.push('/oem-signup')

    // const response = await api_call(`/api/smartcar/get-login-url`);
    // if (response.ok) {
    //   const res = await response.json()
    //   console_log("smartcar res:::", res)
    //   setSettingPersist('smartcar_auth_source', 'signup')
    //   window.location.href = res.link
    //   //history.push('/smartcar-device')
    // } else {
    //   alert("Smartcar authentication error")
    // }
  }

  const onOkDeviceSignupConfirmModal = async () => {
    history.push('/device-signup');
  }

  const [openDeviceSignupConfirmModal, setOpenDeviceSignupConfirmModal] = useState(false)
  const showDeviceSignupConfirmModal = () => {
    setOpenDeviceSignupConfirmModal(true)
  }

  const onCancelDeviceSignupConfirmModal = () => {
    setOpenDeviceSignupConfirmModal(false)
  }

  return (
    <>
      <Helmet>
        <title>Login | MooveTrax</title>
        <link rel="canonical" href="https://b.moovetrax.com/login" />
      </Helmet>

      <StartPage>
        <Grid container direction="column" spacing={2}>
          {useMediaQuery(theme.breakpoints.down('md'))
            && (
              <Grid item className={classes.logoContainer}>
                <Link to="/">
                  <img height="85" width="240" src="/logo.png" alt="Moovetrax" />
                </Link>
                {
                  (isChrome) ? (<></>) : (
                    <a href={GOOGLE_CHROME_URL} target="_blank" className={classes.chromeLogoContainer}>
                      <img src={GOOGLE_CHROME_LOGO} className={classes.chromeLogoImg} alt="Moovetrax Logo Chrome" />
                      <span className={classes.chromeLogoTxt}>Get Google Chrome</span>
                    </a>
                  )
                }
              </Grid>
            )}
          <Grid item>
            <TextField
              required
              fullWidth
              error={failed}
              label={t('userEmail')}
              name="email"
              value={email}
              autoComplete="email"
              autoFocus={!email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyUp={handleSpecialKey}
              helperText={failed && 'Invalid username or password'}
              variant="filled"
            />
          </Grid>
          <Grid item>
            <TextField
              required
              fullWidth
              error={failed}
              label={t('userPassword')}
              name="password"
              value={password}
              type="password"
              autoComplete="current-password"
              autoFocus={!!email}
              onChange={(e) => setPassword(e.target.value)}
              onKeyUp={handleSpecialKey}
              variant="filled"
            />
          </Grid>
          {
            (RECAPTCHA_ENABLED === "true") && (
              <Grid item>
                <CaptchaBox
                  recaptcha={recaptcha}
                  setRecaptcha={setRecaptcha}
                  captchaKey={captchaKey}
                  captchaTimestamp={captchaTimestamp}
                />
              </Grid>
            )
          }

          <Grid item>
            <Button
              onClick={handleSubmit}
              onKeyUp={handleSpecialKey}
              variant="contained"
              color="secondary"
              disabled={!email || !password || !recaptcha}
              fullWidth
            >
              {t('loginLogin')}
            </Button>
          </Grid>
          <Grid container spacing={1}>
            <Grid item style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              {/* <Button onClick={() => history.push('/register')} color="secondary">
              {t('loginRegister')}
            </Button> */}
              <Button onClick={() => history.push('/reset-password')} className={classes.resetPassword} underline="none" color="secondary">{t('loginReset')}</Button>
              <Button onClick={() => history.push('/installer-login')} color="secondary">
                Installer Login
              </Button>
            </Grid>

            <Grid item style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: 0 }}>
              <Button onClick={() => onClickSmartcarSignup()} color="secondary">
                Tesla + OEM Signup
              </Button>
              <Button onClick={() => history.push('/device-signup')} color="secondary">
                Register
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box style={{ width: '100%', paddingTop: '24px' }}>
              <Stack direction={isMobile ? `column` : `row`} justifyContent={isMobile ? `center` : `center`} alignItems={isMobile ? `center` : `center`} spacing={2}>
                <ButtonBase disableRipple href={APP_INTRO_PAGE_LINK} target="_blank" rel="noopener">
                  <img src={`/images/app_icon/android.png`} style={{ width: isMobile ? '75%' : '150px' }} />
                </ButtonBase>
                <ButtonBase disableRipple href={APP_INTRO_PAGE_LINK} target="_blank" rel="noopener">
                  <img src={`/images/app_icon/ios.png`} style={{ width: isMobile ? '75%' : '150px' }} />
                </ButtonBase>
              </Stack>
            </Box>
          </Grid>
        </Grid>

        {
          (showAgreeModal) && (
            <>
              <LoginAgreeModal
                open={showAgreeModal}
                setOpen={setShowAgreeModal}
                onClickAgree={onClickAgree}
                onClickCancel={onClickCancel}
              />
            </>
          )
        }
        <ConfirmDialog
          open={openDeviceSignupConfirmModal}
          setOpen={setOpenDeviceSignupConfirmModal}
          title={APP_NAME}
          content={"Your Device Must First Be On"}
          textYes={`Yes`}
          textNo={`Cancel`}
          onClickYes={() => onOkDeviceSignupConfirmModal()}
          onClickNo={() => onCancelDeviceSignupConfirmModal()}
        />
      </StartPage>
    </>
  )
}

export default LoginForm;
